import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DatabaseEnvPage } from './database-env';
import { AddDatabaseEnvComponent } from './add-database-env/add-database-env.component';
import { BaseAppRouteGuardService } from '../core/services/base-app-route-guard.service';
import { DatabaseEnvDetailsComponent } from './database-env-details/database-env-details.component';
import { UpdateDatabaseEnvComponent } from './update-database-env/update-database-env.component';

const routes: Routes = [
  {
    path: '',
    component: DatabaseEnvPage,
    canActivate: [BaseAppRouteGuardService],
    data : {
      title: "Database Environment",
      Permission : 'JDBC_ENV_LIST'
    }
  },
  {
    path: 'add',
    component: AddDatabaseEnvComponent,
    canActivate: [BaseAppRouteGuardService],
    data : {
      Permission : 'JDBC_ENV_ADD'
    }
  },
  {
    path: 'update/:id',
    component: UpdateDatabaseEnvComponent,
    canActivate: [BaseAppRouteGuardService],
    data : {
      Permission : 'JDBC_ENV_EDIT'
    }
  },
  {
    path: 'details/:id',
    component: DatabaseEnvDetailsComponent,
    canActivate: [BaseAppRouteGuardService],
    data : {
      Permission : 'JDBC_ENV_DETAILS'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DatabaseEnvPageRoutingModule {}
